/**
 * Category consolidation map.
 * Consolidates all post categories into 7 clean, authoritative, minimal core pillars:
 * 1. Systems Architecture (55 posts)
 * 2. Revenue Operations (26 posts)
 * 3. Artificial Intelligence (33 posts)
 * 4. Automation Strategy (21 posts)
 * 5. Hiring Strategy (107 posts)
 * 6. Agency Scaling (66 posts)
 * 7. Compensation & Logistics (56 posts)
 * Total: 364 posts across exactly 7 clean categories + All.
 */
const CATEGORY_MAP: Record<string, string> = {
  // 1. Core Pillar: Systems Architecture
  "Systems Architecture": "Systems Architecture",
  "CRM Architecture": "Systems Architecture",
  "Data Architecture": "Systems Architecture",
  "SaaS Architecture": "Systems Architecture",
  "Systems Integration": "Systems Architecture",
  "System Optimization": "Systems Architecture",
  "System Reliability": "Systems Architecture",
  "System Specialists": "Systems Architecture",
  "HubSpot Architecture": "Systems Architecture",
  "HubSpot Optimization": "Systems Architecture",
  "Data & Tracking": "Systems Architecture",

  // 2. Core Pillar: Revenue Operations
  "Revenue Operations": "Revenue Operations",
  RevOps: "Revenue Operations",
  "Sales Systems": "Revenue Operations",
  "Conversion Optimization": "Revenue Operations",
  "Conversion Engineering": "Revenue Operations",
  "Sales Ops & Analytics": "Revenue Operations",
  "Lead Generation": "Revenue Operations",

  // 3. Core Pillar: Artificial Intelligence
  "Artificial Intelligence": "Artificial Intelligence",
  "AI Voice Automation": "Artificial Intelligence",
  "Agentic AI": "Artificial Intelligence",
  "AI Automation": "Artificial Intelligence",
  "AI & Next-Gen Talent": "Artificial Intelligence",
  "Next-Gen AI": "Artificial Intelligence",

  // 4. Core Pillar: Automation Strategy
  "Automation Strategy": "Automation Strategy",
  "Advanced Automation": "Automation Strategy",
  "API Orchestration": "Automation Strategy",
  "Sales Automation": "Automation Strategy",
  "Client Delivery & Onboarding": "Automation Strategy",
  "Client Onboarding": "Automation Strategy",

  // 5. Core Pillar: Hiring Strategy
  "Hiring Strategy": "Hiring Strategy",
  "Hiring Guide": "Hiring Strategy",
  "Technical Hiring": "Hiring Strategy",
  "Elite Arbitrage Hiring": "Hiring Strategy",
  "Pain & Evaluation": "Hiring Strategy",
  "Delegation Strategy": "Hiring Strategy",
  "Hiring & Delegation": "Hiring Strategy",
  "Strategic Roles": "Hiring Strategy",
  "High-Caliber & Strategic Roles": "Hiring Strategy",
  "Sourcing Models": "Hiring Strategy",
  "Quality & Vetting": "Hiring Strategy",
  "Talent Arbitrage": "Hiring Strategy",
  "GHL for Filipino VAs": "Hiring Strategy",

  // 6. Core Pillar: Agency Scaling
  "Agency Scaling": "Agency Scaling",
  "Agency Operations": "Agency Scaling",
  Operations: "Agency Scaling",
  "Operations & Management": "Agency Scaling",
  "Management & Tracking": "Agency Scaling",
  "Management & Communication": "Agency Scaling",
  "Infrastructure Scaling": "Agency Scaling",
  "Infrastructure & Operations": "Agency Scaling",
  Infrastructure: "Agency Scaling",
  "Client Retention": "Agency Scaling",

  // 7. Core Pillar: Compensation & Logistics
  "Compensation & Logistics": "Compensation & Logistics",
  "Financial Mechanics": "Compensation & Logistics",
  "Arbitrage Math": "Compensation & Logistics",
  "Legal & Security": "Compensation & Logistics",
  "Security & Trust": "Compensation & Logistics",
  "Security & Compliance": "Compensation & Logistics",
  "Legal & Compliance": "Compensation & Logistics",
};

/**
 * Normalizes any category string to one of the 7 consolidated pillars.
 */
export function normalizeCategory(category: string): string {
  return CATEGORY_MAP[category] || category;
}
